export function getGreeting(user, projects) {
  const h = new Date().getHours();
  const day = new Date().getDay();
  const today = new Date().toISOString().slice(0, 10);
  const tomorrow = new Date(Date.now() + 86400000).toISOString().slice(0, 10);
  const pick = arr => arr[Math.floor(Math.random() * arr.length)];

  const isMember = p =>
    p.team?.includes(user.id) &&
    (user.role === "admin" || p.invites?.[user.id] === "accepted");

  // Show i dag
  if (projects.filter(p => p.date && p.date <= today && today <= (p.end_date || p.date) && isMember(p)).length > 0)
    return pick([
      `Dette er det du har øvd for 🎭`,
      `I dag er det din tur til å skinne ✨`,
      `Showdag! Nyt hvert sekund av det 🎶`,
      `Scenen er klar. Du er klar 🎭`
    ]);

  // Show i morgen
  if (projects.filter(p => p.date === tomorrow && isMember(p)).length > 0)
    return pick([
      `I morgen er det show. Du er klar for dette 💪`,
      `En natt til. Så er det din tur 🎭`,
      `Siste forberedelser før showet. Du har det 👊`,
      `I morgen skjer det. Gleder oss for deg 🌟`
    ]);

  // Øving i dag
  if (projects.some(p => isMember(p) && (p.modules?.rehearsals_data || []).some(r => r.date === today)))
    return pick([
      `Øvingsdag! Her bygges showet 💪`,
      `Hver øving bringer deg nærmere showet 🎯`,
      `God øving starter med god forberedelse 🎶`,
      `I dag blir du litt bedre enn i går 🌟`
    ]);

  // Ubesvarte invitasjoner
  const pending = projects.filter(p => p.team?.includes(user.id) && p.invites?.[user.id] === "pending").length;
  if (pending > 0)
    return pick([
      `Du har ${pending} ny${pending > 1 ? "e" : ""} mulighet${pending > 1 ? "er" : ""} som venter 🌟`,
      `Spennende ting på vei – sjekk invitasjonene dine ✉️`,
      `Noen vil ha deg med på laget 👊`
    ]);

  // Ingen kommende jobber
  if (!projects.some(p => isMember(p) && new Date(p.date + "T12:00:00") >= new Date()))
    return pick([
      `Stille før stormen 🎭`,
      `Lader opp til neste runde 💪`,
      `De beste kapitlene er ennå ikke skrevet 🌟`,
      `Neste show er på vei. Vi er klare 🎶`
    ]);

  // Lørdag
  if (day === 6)
    return pick([
      `Lørdag! Noen av de beste showene skjer i dag 🎭`,
      `Helgens magi starter her 🌟`,
      `Lørdagsvibes. Det beste kommer nå 🎶`
    ]);

  // Søndag
  if (day === 0)
    return pick([
      `Søndag og klar for en ny uke 💪`,
      `Hvil godt. Store ting venter 🌟`,
      `Ta vare på energien – du trenger den 🎭`
    ]);

  // Mandag
  if (day === 1)
    return pick([
      `Ny uke, nye muligheter 🌟`,
      `Uken starter her. La oss gjøre den bra 💪`,
      `Frisk start på en ny uke 🎶`
    ]);

  // Fredag
  if (day === 5)
    return pick([
      `Fredag! Avslutt uken på topp 💪`,
      `Ukens siste push. Du klarer det 🌟`,
      `Fredag og klar for det som kommer 🎭`
    ]);

  // Morgen
  if (h >= 5 && h < 9)
    return pick([
      `God morgen! En ny dag med nye muligheter ☀️`,
      `Tidlig ute – vi liker deg 💪`,
      `Kaffe og backstage. Perfekt start ☕`,
      `Dagen er din. Bruk den godt 🌟`,
      `Frisk morgen, friskt hode ☀️`
    ]);

  // Formiddag
  if (h >= 9 && h < 12)
    return pick([
      `God formiddag! Alt er klart for deg her 🎯`,
      `Dagen er i gang og du er på rett sted 💪`,
      `Oversikten du trenger er akkurat her 🌟`,
      `Klar for en produktiv dag 🎶`
    ]);

  // Ettermiddag
  if (h >= 12 && h < 17)
    return pick([
      `Ettermiddagen er her – hold trøkket oppe 💪`,
      `Midt i det beste av dagen 🌟`,
      `Du gjør en fantastisk jobb 🎯`,
      `Halvveis – og du er i toppform 🎶`
    ]);

  // Kveld
  if (h >= 17 && h < 21)
    return pick([
      `Kvelden er showets beste venn 🎭`,
      `Dette er magiens time 🌟`,
      `Kveldsøkt – du gir alt 💪`,
      `Showtime nærmer seg 🎶`
    ]);

  // Natt
  return pick([
    `Du brenner for dette, og det syns 🌙`,
    `Dedikasjon på sitt beste 🌟`,
    `Mens andre sover, forbereder du deg 💪`,
    `Sene kvelder bygger store show 🎭`
  ]);
}